import { SVGProps } from "react";

export default function HeartReactionIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#757575", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17.1557 4.14134C17.8891 4.96634 18.3307 6.04967 18.3307 7.24134C18.3307 13.0747 12.9307 16.5163 10.5141 17.3497C10.2307 17.4497 9.76406 17.4497 9.48073 17.3497C7.06406 16.5163 1.66406 13.0747 1.66406 7.24134C1.66406 4.66634 3.73906 2.58301 6.2974 2.58301C7.81406 2.58301 9.15573 3.31634 9.9974 4.44967C10.8391 3.31634 12.1891 2.58301 13.6974 2.58301"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
